module.exports = __webpack_public_path__ + "static/sec11-shoe-318f6e090163d7a03948602e081c46c1.png";